const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export const formatMoneyWithZeroCents = (number: number) => {
    return formatter.format(number);
};

export const formatMoney = (number: number) => {
    return formatter.format(number).replace('.00', '');
};
